import { CompetitorVsPage } from '../../components/comparisons/CompetitorVsPage';
import { getCompetitorComparison } from '../../data/competitor-comparisons';
import { COMPETITOR_PRICING, COMPETITOR_PRICING_MAX_AGE_DAYS } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

const entry = getCompetitorComparison('frame-io-vs-wipster');

export default function FrameIoVsWipsterPage() {
  return (
    <CompetitorVsPage
      entry={entry}
      documentTitle="Frame.io vs Wipster (2026): Features & Pricing"
      metaDescription="Frame.io vs Wipster compared: editing-software panels, guest review, approvals, per-user pricing, free plan and when each is the better choice."
      h1="Frame.io vs Wipster"
      heroText="Two per-user video review tools compared on integrations, approvals, user limits and price."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="7"
      coverSrc="https://a.storyblok.com/f/287637539865613/2250x750/7b1d4796a1/kreatli-vs-frame-io-2026-the-freshest-most-practical-comparison-for-creative-teams.png"
      coverAlt="Frame.io vs Wipster comparison"
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-comparisons', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  warnStaleEntries(
    'competitor-pricing',
    COMPETITOR_PRICING.filter((pricing) => pricing.id === entry.a || pricing.id === entry.b),
    COMPETITOR_PRICING_MAX_AGE_DAYS,
  );
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
